import { Users, Star, Building2, Phone } from "lucide-react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface ContactStatsProps {
  totalContacts: number;
  decisionMakers: number;
  withEmail: number;
  withPhone: number;
}

export function ContactStats({ 
  totalContacts, 
  decisionMakers, 
  withEmail, 
  withPhone 
}: ContactStatsProps) {
  const stats = [
    {
      label: "Total Contacts",
      value: totalContacts,
      icon: Users,
      color: "text-primary bg-primary/10",
    },
    {
      label: "Decision Makers",
      value: decisionMakers,
      icon: Star,
      color: "text-warning bg-warning/10",
    },
    {
      label: "With Email",
      value: withEmail,
      icon: Building2,
      color: "text-success bg-success/10",
    },
    {
      label: "With Phone",
      value: withPhone,
      icon: Phone,
      color: "text-accent bg-accent/10",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <Card key={stat.label} className="p-4 hover:shadow-lg transition-shadow">
            <div className="flex items-center gap-3">
              <div className={cn("p-2 rounded-lg", stat.color)}>
                <Icon className="h-5 w-5" />
              </div>
              <div>
                <p className="text-2xl font-bold">{stat.value}</p>
                <p className="text-xs text-muted-foreground">{stat.label}</p>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
}
